import { MessageService } from '@progress/kendo-angular-l10n';
import { BlahService } from '@headpower/blah-ng';
import { Injectable } from '@angular/core';

@Injectable()
export class LocalizationMessageService extends MessageService {

    constructor(private blahService: BlahService) { super(); }

    public override get(key: string): string {
        const messages = {
            "kendo.grid.autosizeAllColumns": "Auto size",
            'kendo.grid.detailCollapse': 'task.tasklist.detailCollapse',
            'kendo.grid.detailExpand': 'task.tasklist.detailExpand',
            'kendo.grid.groupPanelEmpty': 'task.tasklist.groupPanelEmpty',
            'kendo.grid.noRecords': 'task.tasklist.noRecords',
            'kendo.grid.pagerFirstPage': 'task.tasklist.pagerFirstPage',
            'kendo.grid.pagerPreviousPage': 'task.tasklist.pagerPreviousPage',
            'kendo.grid.pagerNextPage': 'task.tasklist.pagerNextPage',
            'kendo.grid.pagerLabel': '',
            'kendo.grid.pagerLastPage': 'task.tasklist.pagerLastPage',
            'kendo.grid.pagerPage': 'task.tasklist.pagerPage',
            'kendo.grid.pagerOf': 'task.tasklist.pagerOf',
            'kendo.grid.pagerItems': 'task.tasklist.pagerItems',
            'kendo.grid.pagerItemsPerPage': 'task.tasklist.pagerItemsPerPage',
            'kendo.grid.pagerPageNumberInputTitle': '',
            "kendo.grid.selectPage": "Valitse sivu",
            'kendo.grid.filterEqOperator': 'task.tasklist.filterEqOperator',
            'kendo.grid.filterNotEqOperator': 'task.tasklist.filterNotEqOperator',
            'kendo.grid.filterInputLabel': '',
            'kendo.grid.filterIsNullOperator': 'task.tasklist.filterIsNullOperator',
            'kendo.grid.filterIsNotNullOperator': 'task.tasklist.filterIsNotNullOperator',
            'kendo.grid.filterIsEmptyOperator': 'task.tasklist.filterIsEmptyOperator',
            'kendo.grid.filterIsNotEmptyOperator': 'task.tasklist.filterIsNotEmptyOperator',
            'kendo.grid.filterStartsWithOperator': 'task.tasklist.filterStartsWithOperator',
            'kendo.grid.filterContainsOperator': 'task.tasklist.filterContainsOperator',
            'kendo.grid.filterNotContainsOperator': 'task.tasklist.filterNotContainsOperator',
            'kendo.grid.filterEndsWithOperator': 'task.tasklist.filterEndsWithOperator',
            'kendo.grid.filterGteOperator': 'task.tasklist.filterGteOperator',
            'kendo.grid.filterGtOperator': 'task.tasklist.filterGtOperator',
            'kendo.grid.filterLteOperator': 'task.tasklist.filterLteOperator',
            'kendo.grid.filterLtOperator': 'task.tasklist.filterLtOperator',
            'kendo.grid.filterIsTrue': 'task.tasklist.filterIsTrue',
            'kendo.grid.filterIsFalse': 'task.tasklist.filterIsFalse',
            'kendo.grid.filterBooleanAll': 'task.tasklist.filterBooleanAll',
            'kendo.grid.filterAfterOrEqualOperator': 'task.tasklist.filterAfterOrEqualOperator',
            'kendo.grid.filterAfterOperator': 'task.tasklist.filterAfterOperator',
            'kendo.grid.filterBeforeOperator': 'task.tasklist.filterBeforeOperator',
            'kendo.grid.filterBeforeOrEqualOperator': 'task.tasklist.filterBeforeOrEqualOperator',
            'kendo.grid.filterFilterButton': 'task.tasklist.filterFilterButton',
            'kendo.grid.filterClearButton': 'task.tasklist.filterClearButton',
            'kendo.grid.filterAndLogic': 'task.tasklist.filterAndLogic',
            'kendo.grid.filterOrLogic': 'task.tasklist.filterOrLogic',
            'kendo.grid.filter': 'task.tasklist.filter',
            'kendo.grid.filterDateToday': '',
            'kendo.grid.filterDateToggle': '',
            'kendo.grid.filterMenuLogicDropDownLabel': '',
            'kendo.grid.filterMenuOperatorsDropDownLabel': '',
            'kendo.grid.filterMenuTitle': '',
            'kendo.grid.filterNumericDecrement': '',
            'kendo.grid.filterNumericIncrement': '',

            'kendo.grid.loading': 'task.tasklist.loading',
            'kendo.grid.columnMenu': 'task.tasklist.columnMenu',
            'kendo.grid.columns': 'task.tasklist.columns',
            'kendo.grid.lock': 'task.tasklist.lock',
            'kendo.grid.unlock': 'task.tasklist.unlock',
            'kendo.grid.unstick': 'task.tasklist.unlock',
            'kendo.grid.selectAllCheckboxLabel': '',
            'kendo.grid.selectionCheckboxLabel': '',
            'kendo.grid.setColumnPosition': '',
            'kendo.grid.sortable': 'task.tasklist.sortable',
            'kendo.grid.sortAscending': 'task.tasklist.sortAscending',
            'kendo.grid.sortDescending': 'task.tasklist.sortDescending',
            'kendo.grid.sortedAscending': 'task.tasklist.sortedAscending',
            'kendo.grid.sortedDescending': 'task.tasklist.sortedDescending',
            'kendo.grid.sortedDefault': 'task.tasklist.sortedDefault',
            'kendo.grid.stick': '',
            'kendo.grid.columnsApply': 'task.tasklist.columnsApply',
            'kendo.grid.columnsReset': 'task.tasklist.columnsReset',
            'kendo.grid.gridLabel': '',
            'kendo.grid.groupCollapse': '',
            'kendo.grid.groupExpand': '',


            'kendo.datepicker.toggle': 'task.tasklist.toggle',
            'kendo.datepicker.today': 'task.tasklist.today',
            'kendo.dropdownlist.noDataText': 'task.tasklist.noDataText',
            'kendo.dropdownlist.selectButtonText': '',
            'kendo.label.optional': 'task.tasklist.optional',

            'kendo.upload.cancel': 'task.attachment.cancel',
            'kendo.upload.headerStatusUploaded': 'task.attachment.headerStatusUploaded',
            'kendo.upload.invalidFileExtension': 'task.attachment.invalidFileExtension',
            'kendo.upload.invalidFiles': 'task.attachment.invalidFiles',
            'kendo.upload.invalidMaxFileSize': 'default.attachmentInvalidMaxFileSize',
            'kendo.upload.invalidMinFileSize': 'task.attachment.invalidMinFileSize',
            'kendo.upload.remove': 'task.attachment.remove',
            'kendo.upload.retry': 'task.attachment.retry',
            'kendo.upload.pause': '',
            'kendo.upload.resume': '',
            'kendo.upload.filesBatchStatus': '',
            'kendo.upload.filesBatchStatusFailed': '',
            'kendo.upload.filesBatchStatusUploaded': '',
            'kendo.upload.fileStatusFailed': '',
            'kendo.upload.fileStatusUploaded': '',
            'kendo.upload.headerStatusPaused': '',

            'kendo.gantt.taskEditingGeneralTabTitle': '',
            'kendo.gantt.taskEditingPredecessorsTabTitle': '',
            'kendo.gantt.taskEditingSuccessorsTabTitle': '',
            'kendo.gantt.taskEditingDependenciesAddButtonText': '',
            'kendo.gantt.taskEditingDependenciesRemoveButtonText': '',
            'kendo.gantt.taskEditingDependenciesGridNameColumnTitle': '',
            'kendo.gantt.taskEditingDependenciesGridTypeColumnTitle': '',
            'kendo.gantt.deleteButtonText': '',
            'kendo.gantt.taskDeleteLabel': '',
            'kendo.gantt.taskEditingDialogTitle': '',
            'kendo.gantt.taskEditingDialogCloseTitle': '',
            'kendo.gantt.confirmationDialogCloseTitle': '',
            'kendo.gantt.confirmationDialogTitle': '',
            'kendo.gantt.addTaskText': '',
            'kendo.gantt.addChildText': '',
            'kendo.gantt.addAboveText': '',
            'kendo.gantt.addBelowText': '',
            'kendo.gantt.cancelButtonText': '',
            'kendo.gantt.saveButtonText': '',
            'kendo.gantt.titleFieldInputLabel': '',
            'kendo.gantt.startFieldInputLabel': '',
            'kendo.gantt.endFieldInputLabel': '',
            'kendo.gantt.completionRatioFieldInputLabel': '',
            'kendo.gantt.confirmationDialogContent': '',
            'kendo.gantt.dayViewText': 'default.calendarDay', // Gantt view button
            'kendo.gantt.weekViewText': 'default.calendarWeek', // Gantt view button
            'kendo.gantt.monthViewText': 'default.calendarMonth', // Gantt view button
            'kendo.gantt.yearViewText': 'default.calendarYear',  // Gantt view button
            'kendo.gantt.noRecords': '',
            'kendo.gantt.filter': '',
            'kendo.gantt.filterEqOperator': '',
            'kendo.gantt.filterNotEqOperator': '',
            'kendo.gantt.filterIsNullOperator': '',
            'kendo.gantt.filterIsNotNullOperator': '',
            'kendo.gantt.filterIsEmptyOperator': '',
            'kendo.gantt.filterIsNotEmptyOperator': '',
            'kendo.gantt.filterStartsWithOperator': '',
            'kendo.gantt.filterContainsOperator': '',
            'kendo.gantt.filterNotContainsOperator': '',
            'kendo.gantt.filterEndsWithOperator': '',
            'kendo.gantt.filterGteOperator': '',
            'kendo.gantt.filterGtOperator': '',
            'kendo.gantt.filterLteOperator': '',
            'kendo.gantt.filterLtOperator': '',
            'kendo.gantt.filterIsTrue': '',
            'kendo.gantt.filterIsFalse': '',
            'kendo.gantt.filterBooleanAll': '',
            'kendo.gantt.filterAfterOrEqualOperator': '',
            'kendo.gantt.filterAfterOperator': '',
            'kendo.gantt.filterBeforeOperator': '',
            'kendo.gantt.filterBeforeOrEqualOperator': '',
            'kendo.gantt.filterFilterButton': '',
            'kendo.gantt.filterClearButton': '',
            'kendo.gantt.filterAndLogic': '',
            'kendo.gantt.filterOrLogic': '',
            'kendo.gantt.loading': '',
            'kendo.gantt.columnMenu': '',
            'kendo.gantt.columns': '',
            'kendo.gantt.sortable': '',
            'kendo.gantt.sortAscending': '',
            'kendo.gantt.sortDescending': '',
            'kendo.gantt.sortedAscending': '',
            'kendo.gantt.sortedDescending': '',
            'kendo.gantt.sortedDefault': '',
            'kendo.gantt.columnsApply': '',
            'kendo.gantt.columnsReset': '',
            'kendo.treelist.pagerFirstPage': '',
            'kendo.treelist.pagerLastPage': '',
            'kendo.treelist.pagerPreviousPage': '',
            'kendo.treelist.pagerNextPage': '',
            'kendo.treelist.pagerPage': '',
            'kendo.treelist.pagerPageNumberInputTitle': '',
            'kendo.treelist.pagerItemsPerPage': '',
            'kendo.treelist.pagerOf': '',
            'kendo.treelist.pagerItemsTotal': '',
            'kendo.treelist.lock': '',
            'kendo.treelist.unlock': '',
            'kendo.treelist.noRecords': '',
            'kendo.treelist.filter': '',
            'kendo.treelist.filterEqOperator': '',
            'kendo.treelist.filterNotEqOperator': '',
            'kendo.treelist.filterIsNullOperator': '',
            'kendo.treelist.filterIsNotNullOperator': '',
            'kendo.treelist.filterIsEmptyOperator': '',
            'kendo.treelist.filterIsNotEmptyOperator': '',
            'kendo.treelist.filterStartsWithOperator': '',
            'kendo.treelist.filterContainsOperator': '',
            'kendo.treelist.filterNotContainsOperator': '',
            'kendo.treelist.filterEndsWithOperator': '',
            'kendo.treelist.filterGteOperator': '',
            'kendo.treelist.filterGtOperator': '',
            'kendo.treelist.filterLteOperator': '',
            'kendo.treelist.filterLtOperator': '',
            'kendo.treelist.filterIsTrue': '',
            'kendo.treelist.filterIsFalse': '',
            'kendo.treelist.filterBooleanAll': '',
            'kendo.treelist.filterAfterOrEqualOperator': '',
            'kendo.treelist.filterAfterOperator': '',
            'kendo.treelist.filterBeforeOperator': '',
            'kendo.treelist.filterBeforeOrEqualOperator': '',
            'kendo.treelist.filterFilterButton': '',
            'kendo.treelist.filterClearButton': '',
            'kendo.treelist.filterAndLogic': '',
            'kendo.treelist.filterOrLogic': '',
            'kendo.treelist.loading': '',
            'kendo.treelist.columnMenu': '',
            'kendo.treelist.columns': '',
            'kendo.treelist.sortable': '',
            'kendo.treelist.sortAscending': '',
            'kendo.treelist.sortDescending': '',
            'kendo.treelist.sortedAscending': '',
            'kendo.treelist.sortedDescending': '',
            'kendo.treelist.sortedDefault': '',
            'kendo.treelist.columnsApply': '',
            'kendo.treelist.columnsReset': '',
            'kendo.treelist.selectPage': '',

            'kendo.pager.taskEditingGeneralTabTitle': '',
            'kendo.pager.taskEditingPredecessorsTabTitle': '',
            'kendo.pager.taskEditingSuccessorsTabTitle': '',
            'kendo.pager.taskEditingDependenciesAddButtonText': '',
            'kendo.pager.taskEditingDependenciesRemoveButtonText': '',
            'kendo.pager.taskEditingDependenciesGridNameColumnTitle': '',
            'kendo.pager.taskEditingDependenciesGridTypeColumnTitle': '',
            'kendo.pager.deleteButtonText': '',
            'kendo.pager.taskDeleteLabel': '',
            'kendo.pager.taskEditingDialogTitle': '',
            'kendo.pager.taskEditingDialogCloseTitle': '',
            'kendo.pager.confirmationDialogCloseTitle': '',
            'kendo.pager.confirmationDialogTitle': '',
            'kendo.pager.addTaskText': '',
            'kendo.pager.addChildText': '',
            'kendo.pager.addAboveText': '',
            'kendo.pager.addBelowText': '',
            'kendo.pager.cancelButtonText': '',
            'kendo.pager.saveButtonText': '',
            'kendo.pager.titleFieldInputLabel': '',
            'kendo.pager.startFieldInputLabel': '',
            'kendo.pager.endFieldInputLabel': '',
            'kendo.pager.completionRatioFieldInputLabel': '',
            'kendo.pager.confirmationDialogContent': '',
            'kendo.pager.dayViewText': 'default.calendarDay', // Gantt view button
            'kendo.pager.weekViewText': 'default.calendarWeek', // Gantt view button
            'kendo.pager.monthViewText': 'default.calendarMonth', // Gantt view button
            'kendo.pager.yearViewText': 'default.calendarYear',  // Gantt view button
            'kendo.pager.noRecords': '',
            'kendo.pager.filter': '',
            'kendo.pager.filterEqOperator': '',
            'kendo.pager.filterNotEqOperator': '',
            'kendo.pager.filterIsNullOperator': '',
            'kendo.pager.filterIsNotNullOperator': '',
            'kendo.pager.filterIsEmptyOperator': '',
            'kendo.pager.filterIsNotEmptyOperator': '',
            'kendo.pager.filterStartsWithOperator': '',
            'kendo.pager.filterContainsOperator': '',
            'kendo.pager.filterNotContainsOperator': '',
            'kendo.pager.filterEndsWithOperator': '',
            'kendo.pager.filterGteOperator': '',
            'kendo.pager.filterGtOperator': '',
            'kendo.pager.filterLteOperator': '',
            'kendo.pager.filterLtOperator': '',
            'kendo.pager.filterIsTrue': '',
            'kendo.pager.filterIsFalse': '',
            'kendo.pager.filterBooleanAll': '',
            'kendo.pager.filterAfterOrEqualOperator': '',
            'kendo.pager.filterAfterOperator': '',
            'kendo.pager.filterBeforeOperator': '',
            'kendo.pager.filterBeforeOrEqualOperator': '',
            'kendo.pager.filterFilterButton': '',
            'kendo.pager.filterClearButton': '',
            'kendo.pager.filterAndLogic': '',
            'kendo.pager.filterOrLogic': '',
            'kendo.pager.loading': '',
            'kendo.pager.columnMenu': '',
            'kendo.pager.columns': '',
            'kendo.pager.sortable': '',
            'kendo.pager.sortAscending': '',
            'kendo.pager.sortDescending': '',
            'kendo.pager.sortedAscending': '',
            'kendo.pager.sortedDescending': '',
            'kendo.pager.sortedDefault': '',
            'kendo.pager.columnsApply': '',
            'kendo.pager.columnsReset': '',
            'kendo.pager.firstPage': '',
            'kendo.pager.lastPage': '',
            'kendo.pager.previousPage': '',
            'kendo.pager.nextPage': '',
            'kendo.pager.page': '',
            'kendo.pager.pageNumberInputTitle': '',
            'kendo.pager.itemsPerPage': 'task.tasklist.pagerItemsPerPage',
            'kendo.pager.of': '',
            'kendo.pager.items': '',
            'kendo.pager.selectPage': '',
            'kendo.pager.inputLabel': ''
        }

        if (messages[key] === undefined) {
            console.warn(`Key ${key} not defined in LocalizationMessageService.`)
            return '';
        }

        const translationKey = messages[key];
        if (translationKey === '') {
            return '';
        }

        return this.blahService.blah(translationKey);
    }
}
